import React, { Component } from 'react'
import styled from 'styled-components'
import { Form as OriginalForm } from 'formsy-react'
import {
  Button,
  Checkbox,
  Modal,
  TextInput,
} from 'advenio-components'

import {
  ValidateDatePayU,
  isValidCardNumber,
} from './Validations'
import {
  PAYU_LINK,
  PAYU_ACCOUNT_ID,
  PAYU_PUBLIC_KEY,
} from '../../config'
import ErrorIsland from '../ErrorIsland'

const ModalHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px;
  border-bottom: 1px solid #cecece;
`
const CloseModal = styled.div`
  margin: 8px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  img {
    width: 20px;
  }
`
const ModalContent = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 16px;
  flex-direction: row;
  flex-wrap: wrap;
`
const Form = styled(OriginalForm)`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
`
const InputRow = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: baseline;
  flex-wrap: wrap;
  @media (max-width: 763px) {
    flex-direction: column;
  }
`
const InputContainer = styled.div`
  width: 200px;
  margin: 0 16px 0 16px;
  ${props => props.hide && 'display: none'}
`
const InputContainerSmall = styled.div`
  width: 80px;
  margin: 0 8px 0 0px;
`
const FormContainer = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-direction: row;
  flex-wrap: wrap;
  width: 500px;
  @media (max-width: 763px) {
    flex-direction: column;
  }
`
const ButtonsContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
  width: 100%;
  @media (max-width: 763px) {
    justify-content: center;
  }
`
const DateContainer = styled.div`
  margin-left: 16px;
  display: flex;
  align-items: center;
  span {
    margin-right: 8px;
  }
`
const ErrorContainer = styled.div`
  color: red;
  font-size: 14px;
  max-width: 160px;
  padding-left: 16px;
  margin-bottom: 8px;
`

class CreateCardModalPayU extends Component {
  state = {
    errorDate: false,
    sendDisable: true,
    errorFromCardToken: false,
    method: '',
  }

  componentWillMount = () => {
    payU.setURL(PAYU_LINK)
    payU.setPublicKey(PAYU_PUBLIC_KEY)
    payU.setAccountID(PAYU_ACCOUNT_ID)
    payU.setListBoxID('mylistID')
    payU.getPaymentMethods()
  }

  componentDidMount() {
    this.updateWindowDimensions()
    window.addEventListener('resize', this.updateWindowDimensions)
  }

  componentWillReceiveProps = ({ errorAfterCreate }) => {
    if (errorAfterCreate) {
      this.setState({ errorFromCardToken: errorAfterCreate.error })
    }
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.updateWindowDimensions)
  }

  onSubmit = (cardInfo) => {
    const { parent } = this.props

    if (!this.state.errorDate) {
      const card = { ...cardInfo, payer_id: parent.parent_id, method: payU.card.method }
      payU.setCardDetails(card)
      payU.createToken(this.onSuccess(card))
      this.setState({ errorFromCardToken: false })
    }
  }

  onSuccess = cardInfo => (result) => {
    const { sendCard } = this.props

    if (result.error) return this.onError(result.error)
  
    return sendCard({
      token: result.token,
      default: cardInfo.default_card,
      payment_provider: 'PayU',
      expireDate:{'exp_year':cardInfo.exp_year,'exp_month':cardInfo.exp_month},
    })
  }

  onError = (error) => {
    this.setState({ errorFromCardToken: error, sendDisable: true })
  }

  updateWindowDimensions = () => {
    this.setState({ width: window.innerWidth })
  }

  validateDate = ({ exp_month: month, exp_year: year }) => {
    if (month && year) {
      return this.setState({
        errorDate: !ValidateDatePayU(month, year) ? 'Fecha Invalida' : false,
      })
    }

    return this.setState({ errorDate: true })
  }

  validateForm = () => {
    const { errorDate } = this.state
    this.setState({ sendDisable: !!errorDate })
  }

  invalidateForm = () => {
    this.setState({ sendDisable: true })
  }

  requiredField = (e) => {
    if (e.currentTarget.value.length === 0) {
      this.setState({ errorDate: 'Campos obligatorios' })
    }
  }

  beforeClose = () => {
    this.setState(
      {
        errorDate: false,
        sendDisable: true,
        errorFromCardToken: false,
      },
      this.props.onClose,
    )
  }

  render() {
    const { errorFromCardToken, errorDate, sendDisable, width } = this.state
    const { open, onClose, parent, card, loading, forceDefault } = this.props

    return (
      <Modal
        full={width < 763}
        isOpened={open}
        onClose={this.beforeClose}
        statePath="cards"
        actionType="create"
        typePrefix="CARDS"
      >
        <ModalHeader>
          <h2>Agregar Tarjeta</h2>
          <CloseModal onClick={this.beforeClose}>
            <img src="/assets/Close.svg" alt="close" />
          </CloseModal>
        </ModalHeader>
        <ModalContent>
          <Form
            onChange={this.validateDate}
            onValidSubmit={this.onSubmit}
            onValid={this.validateForm}
            onInvalid={this.invalidateForm}
          >
            {!!errorFromCardToken && <ErrorIsland error={errorFromCardToken} />}
            <FormContainer>
              <InputRow>
                <InputContainer hide>
                  <div id="mylistID" className="method_div" />
                </InputContainer>
                <InputContainer hide>
                  <TextInput
                    name="payment_provider"
                    label="Payment Provider"
                    value="PayU"
                    type="hidden"
                  />
                </InputContainer>
                <InputContainer>
                  <TextInput
                    name="name_card"
                    label="Nombre de Tarjetahabiente"
                    value={parent && parent.name}
                    valid={false}
                    required
                  />
                </InputContainer>
                <InputContainer>
                  <TextInput
                    name="number"
                    required
                    label="Numero de tarjeta"
                    validations={{
                      customValidation: isValidCardNumber,
                    }}
                    validationErrors={{
                      customValidation: 'Número de tarjeta inválido',
                    }}
                  />
                </InputContainer>
              </InputRow>
              <InputRow>
                <InputContainer>
                  <TextInput
                    name="cvv"
                    label="CVV"
                    type="number"
                    required
                    validations={{
                      maxLength: 4,
                      isInt: true,
                    }}
                    validationErrors={{
                      maxLength: 'Código Inválido',
                      isInt: 'Error',
                    }}
                  />
                </InputContainer>
                <div>
                  <DateContainer>
                    <InputContainerSmall>
                      <TextInput
                        name="exp_month"
                        label="MM"
                        hideEmptyHelpBlock
                        type="number"
                        onChangeCallback={this.requiredField}
                      />
                    </InputContainerSmall>
                    <InputContainerSmall>
                      <TextInput
                        name="exp_year"
                        label="YY"
                        hideEmptyHelpBlock
                        type="number"
                        onChangeCallback={this.requiredField}
                      />
                    </InputContainerSmall>
                  </DateContainer>
                  <ErrorContainer>{errorDate && errorDate}</ErrorContainer>
                </div>
                <InputContainer>
                  <Checkbox
                    name="default_card"
                    label="¿Usar por default?"
                    value={forceDefault}
                    disabled={forceDefault}
                  />
                </InputContainer>
              </InputRow>
            </FormContainer>
            <ButtonsContainer>
              <Button onClick={this.beforeClose}>Cancelar</Button>
              <Button primary type="submit" disabled={sendDisable} loading={loading}>
                Agregar
              </Button>
            </ButtonsContainer>
          </Form>
        </ModalContent>
      </Modal>
    )
  }
}

export default CreateCardModalPayU



// WEBPACK FOOTER //
// ./src/Components/ProfileViews/CreateCardModalPayU.jsx